import React, { createContext, useContext, useEffect, useMemo, useReducer, useRef } from 'react'
import {
  ConfirmationOfSigningInitialState,
  ConfirmationOfSigningReducer,
} from '../routes/deals/ConfirmationOfSigningDuck'
import { DealsInitialState, DealsReducer } from '../routes/deals/DealsDuck'
import { DocumentsInitialState, DocumentsReducer } from '../routes/financier/DocumentsDuck'
import { FinancierInitialState, FinancierReducer } from '../routes/financier/FinancierDuck'
import { LoginInitialState, LoginReducer } from '../routes/login/LoginDuck'
import { ToastInitialState, ToastReducer } from '../routes/login/ToastDuck'
import { OverviewInitialState, OverviewReducer } from '../routes/overview/OverviewDuck'
import { LiquidationInitialState, LiquidationReducer } from '../routes/portfolio/LiquidationDuck'
import { PortfolioInitialState, PortfolioReducer } from '../routes/portfolio/PortfolioDuck'
import { RegisterInitialState, RegisterReducer } from '../routes/register/RegisterDuck'
import { BannerInitialState, BannerReducer } from '../components/promotional-message/BannerDuck'

export const GlobalContext = createContext({})
export const GlobalDispatchContext = createContext({})

const enchanceDispatchWithLogger = dispatch => {
  return function (action) {
    console.debug('%c' + 'Action Type: ' + action.type, 'color:' + 'blue' + ';font-weight:bold;')
    console.debug(action?.payload)
    return dispatch(action)
  }
}

const useReducerWithLogger = (...args) => {
  const [state, dispatch] = useReducer(...args)
  let prevState = useRef(args[1])

  const dispatchWithLogger = useMemo(() => {
    return enchanceDispatchWithLogger(dispatch)
  }, [dispatch])

  useEffect(() => {
    if (state !== prevState.current) {
      // console.debug('Prev state: ', prevState.current)
      // console.debug('Next state: ', state)
      // console.groupEnd()
    }
    prevState.current = state
  }, [state, args])

  return [state, dispatchWithLogger]
}

export const GlobalProvider = ({ children }) => {
  const [dealsState, dealsDispatch] = useReducerWithLogger(DealsReducer, DealsInitialState)
  const [loginState, loginDispatch] = useReducerWithLogger(LoginReducer, LoginInitialState)
  const [financierState, financierDispatch] = useReducerWithLogger(FinancierReducer, FinancierInitialState)
  const [portfolioState, portfolioDispatch] = useReducerWithLogger(PortfolioReducer, PortfolioInitialState)
  const [overviewState, overviewDispatch] = useReducerWithLogger(OverviewReducer, OverviewInitialState)
  const [confirmationOfSigningState, confirmationOfSigningDispatch] = useReducerWithLogger(
    ConfirmationOfSigningReducer,
    ConfirmationOfSigningInitialState
  )
  const [liquidationState, liquidationDispatch] = useReducerWithLogger(LiquidationReducer, LiquidationInitialState)
  const [registerState, registerDispatch] = useReducerWithLogger(RegisterReducer, RegisterInitialState)
  const [documentsState, documentsDispatch] = useReducerWithLogger(DocumentsReducer, DocumentsInitialState)
  const [toastState, toastDispatch] = useReducerWithLogger(ToastReducer, ToastInitialState)
  const [bannerState, bannerDispatch] = useReducerWithLogger(BannerReducer, BannerInitialState)

  return (
    <GlobalContext.Provider
      value={{
        dealsState,
        documentsState,
        loginState,
        financierState,
        portfolioState,
        overviewState,
        confirmationOfSigningState,
        liquidationState,
        registerState,
        toastState,
        bannerState,
      }}>
      <GlobalDispatchContext.Provider
        value={{
          dealsDispatch,
          documentsDispatch,
          loginDispatch,
          financierDispatch,
          portfolioDispatch,
          overviewDispatch,
          confirmationOfSigningDispatch,
          liquidationDispatch,
          registerDispatch,
          toastDispatch,
          bannerDispatch,
        }}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalContext.Provider>
  )
}

export const useGlobal = () => {
  return useContext(GlobalContext)
}

export const useGlobalDispatch = () => {
  return useContext(GlobalDispatchContext)
}
